<div class="p-6 w-full">
  <!-- BreadCrumb -->
  <div class="header-section">
    <nav class="inter flex items-center space-x-2 text-sm text-gray-700 mb-4">
      <span class="material-symbols-outlined" style="font-size: 18px"
        >home</span
      >
      <span
        class="text-[14px] font-medium color-[#374151] cursor-pointer"
        (click)="navigateToMenu()"
        >Home</span
      >
      <span class="material-symbols-outlined text-[#6B7280]"
        >arrow_forward_ios</span
      >
      <span class="text-[14px] font-medium color-[#374151]"
        >Menú de Sistemas</span
      >
    </nav>
    <h1 class="text-[28px] font-medium text-black w-fit">Menú de Sistemas</h1>
  </div>

  <div
    class="w-full flex flex-col lg:flex-row lg:justify-between lg:items-center"
  >
    <div class="md:w-64 mt-8 mb-4">
      <app-custom-search
        placeholder="Buscar"
        backgroundColor="#ffffff"
        textColor="#374151"
        iconColor="#9ca3af"
        borderColor="#e1e5e9"
        focusBorderColor="#3b82f6"
        [showClearButton]="false"
        (keyup)="onSearchKeyup($event)"
      />
    </div>
    <!-- Botones de acción -->
    <div class="flex flex-col md:flex-row gap-3 lg:mt-6 mb-4 lg:mb-0">
      <!-- Botón Exportar Excel -->
      <app-custom-button
        text="Exportar excel"
        backgroundColor="#5CA42F"
        borderColor="#5CA42F"
        size="md"
        icon='<span class="material-symbols-outlined text-[17px]">file_save</span>'
        iconPosition="left"
        hoverBackgroundColor="#487F25"
        hoverTextColor="#ffffff"
        (click)="exportTable($event)"
      >
      </app-custom-button>

      <!-- Botón Agregar Usuario -->
      <app-custom-button
        text="Agregar"
        backgroundColor="#005FFF"
        borderColor="#005FFF"
        size="md"
        icon='<span class="material-symbols-outlined text-[20px]">add</span>'
        iconPosition="left"
        hoverBackgroundColor="#0549BD"
        hoverTextColor="#ffffff"
        (click)="openModal()"
      >
      </app-custom-button>
    </div>
  </div>

  <!-- Tabla -->
  <mat-card>
    <mat-card-content class="!p-0">
      <div class="flex-1 overflow-x-auto!">
        <table mat-table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="codigoMenu">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              CÓDIGO MENÚ
            </th>
            <td mat-cell *matCellDef="let element">
              <app-custom-tooltip
                text="{{ element.codigoMenu }}"
                position="below"
              >
                {{ element.codigoMenu }}
              </app-custom-tooltip>
            </td>
          </ng-container>

          <ng-container matColumnDef="titulo">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>TÍTULO</th>
            <td mat-cell class="whitespace-normal!" *matCellDef="let element">
              <app-custom-tooltip text="{{ element.titulo }}" position="below">
                {{ element.titulo }}
              </app-custom-tooltip>
            </td>
          </ng-container>

          <ng-container matColumnDef="ruta">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>RUTA</th>
            <td mat-cell *matCellDef="let element">
              <app-custom-tooltip text="{{ element.ruta }}" position="below">
                {{ element.ruta }}
              </app-custom-tooltip>
            </td>
          </ng-container>

          <ng-container matColumnDef="symbol">
            <th mat-header-cell *matHeaderCellDef>EDITAR</th>
            <td mat-cell *matCellDef="let element">
              <button mat-icon-button (click)="openEditModal(element)">
                <span
                  class="material-symbols-outlined"
                  style="
                    font-size: 18px;
                    font-variation-settings: 'opsz' 18;
                    color: #6b7280;
                  "
                >
                  edit_square
                </span>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
      <mat-paginator
        class="pt-3! border-t border-gray-300!"
        [pageSizeOptions]="[10, 25, 100]"
        [showFirstLastButtons]="false"
      ></mat-paginator> </mat-card-content
  ></mat-card>
</div>


<app-custom-modal
  [isOpen]="isOpenModal"
  [title]="editMode ? 'Editar Menú' : 'Agregar Menú'"
  size="md"
  [buttons]="editMode ? editMenuButtons : addMenuButtons"
  (close)="closeModal()"
  (buttonClick)="submitMenuForm()"
>
  <form [formGroup]="menuForm">
    <div class="mb-4">
      <app-input-custom
        label="Código del Menú"
        formControlName="codigoMenu"
        [isDisabled]="editMode"
        [hasError]="(codigoMenu.errors?.['required'] || codigoMenu.errors?.['maxlength']) && submitted"
      />
      @if (submitted && codigoMenu.errors?.['required']) {
        <p class="text-red-600 text-sm font-normal">
          El Código del Menú es obligatorio.
        </p>
      }
      @if (submitted && codigoMenu.errors?.['maxlength']) {
        <p class="text-red-600 text-sm font-normal">
          El Código del Menú no puede tener más de 50 caracteres.
        </p>
      }
    </div>
    <div class="mb-4">
      <app-input-custom
        label="Título *"
        formControlName="titulo"
        [hasError]="(titulo.errors?.['required'] || titulo.errors?.['maxlength']) && submitted"
      />
      @if (submitted && titulo.errors?.['required']) {
        <p class="text-red-600 text-sm font-normal">
          El título es obligatorio.
        </p>
      }
      @if (submitted && titulo.errors?.['maxlength']) {
        <p class="text-red-600 text-sm font-normal">
          El titulo no puede tener más de 100 caracteres.
        </p>
      }
    </div>

    <div class="mb-4">
      <app-input-custom
        label="Ruta *"
        formControlName="ruta"
        [hasError]="(ruta.errors?.['required'] || ruta.errors?.['maxlength']) && submitted"
      />
      @if (submitted && ruta.errors?.['required']) {
        <p class="text-red-600 text-sm font-normal">
          La ruta es obligatorio.
        </p>
      }
      @if (submitted && ruta.errors?.['maxlength']) {
        <p class="text-red-600 text-sm font-normal">
          La ruta no puede tener más de 300 caracteres.
        </p>
      }
    </div>
  </form>
</app-custom-modal>
